<template>
  <p class="p-policy">Welcome to the Draph Solutions S.r.o. Privacy Policy.</p>
  <p class="p-policy">
    Draph Solutions S.r.o. is a company incorporated in the Czech Republic (‘CZ’) with the
    registered company number C 278807, whose registered office address is at Národní 961/25, Staré
    Město, 110 00 Praha 1 (the ‘Draph’, ‘we’, or ‘us’).
  </p>
  <p class="p-policy">We are recognized and provide our services under the trade name ‘Swipez’.</p>
  <p class="p-policy">
    We are offering payment services as a small-scale payment service provider (the ‘SSP’).  We are
    authorised and regulated by the Czech National Bank (the ‘CNB’).
  </p>
  <p class="p-policy">
    Laws of the Czech Republic are applicable and regulate our business activity, provision of our
    services and our relations with the clients and the CNB.
  </p>
  <p class="p-policy">
    It’s of our great importance that you carefully read information provided below and fully
    understand how we use and protect your personal data.
  </p>

  <h2 class="h--large is--white">KEEPING YOUR DATA SAFE</h2>

  <p class="p-policy">
    We are committed to keeping your personal data safe and secure. We handle your personal data in
    accordance with our legal obligations set by the:
  </p>
  <ul role="list" class="bullet--list">
    <li>Personal Data Processing Act 2019 (No. 110/2019 Coll., ‘ZZOÚ’), ‘the Act’,</li>
    <li>
      Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the
      protection of natural persons with regard to the processing of personal data and on the free
      movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation),
      the ‘GDPR’,
    </li>
    <li>best practice recognized standards.</li>
  </ul>
  <p class="p-policy">
    This Privacy Policy is applicable to visitors of our website, existing and prospective clients,
    who use or intend to use our services. Our Privacy Policy details the purposes for which we
    process your personal data, who we share it with, what rights you have in relation to that data
    and everything else we think is important for you to know.
  </p>

  <h2 class="h--large is--white">HOW WE COLLECT YOUR PERSONAL DATA</h2>
  <p class="p-policy">
    We use different methods to collect data from and about you including through:
  </p>
  <ul class="bullet--list">
    <li>
      Direct interactions: you by yourself submit us your personal data. This includes personal data
      you provide when you:
    </li>
    <ul class="bullet--list">
      <li>apply for or use our services via the website or App,</li>
      <li>register with our system on the website, complete forms and questionnaires,</li>
      <li>subscribe to a newsletter,</li>
      <li>request marketing to be sent to you,</li>
      <li>submit complaint,</li>
      <li>enter a competition, promotion or survey, or</li>
      <li>give us feedback or contact us.</li>
    </ul>
    <li>
      Automated technologies or interactions. When you interact with our system, website, App. We
      will automatically collect technical data about your equipment, browsing actions and patterns.
      We collect this personal data by using cookies, server logs and other similar technologies.
    </li>
    <li>
      Third parties or publicly available sources. We may receive personal data about you from
      various third parties and public sources.
    </li>
  </ul>

  <h2 class="h--large is--white">TYPES OF PERSONAL DATA WE COLLECT</h2>

  <p>
    Personal data, or personal information, means any information about an individual from which
    that person can be identified.
  </p>
  <p>
    We may collect, use, store and transfer different types of personal data based on the following
    legal grounds of your data processing:
  </p>
  <ul class="bullet--list">
    <li>Contact Data: includes address, e-mail address phone number, social media,</li>
    <li>
      Identity Data: includes first name, maiden name, surname, any former name, username or similar
      identifier, marital status, title, date of birth, ID number, nationality, citizenship, place
      of birth, tax registration number, role/position.
    </li>
    <li>
      Marketing and Communications Data: includes your preferences in receiving marketing from us
      and other third parties and your communication preferences,
    </li>
    <li>
      Technical Data: includes internet protocol (IP) address, your login data, browser type and
      version, your device, time zone setting and location, browser plug-in types and versions,
      operating system and platform, and other technology on the devices you use to access our
      website, system or App,
    </li>
    <li>
      Usage Data: includes information about how you use our services, website, system or App,
    </li>
    <li>
      Security Data: when you register for our services and account you may be asked to answer
      security questions, create a password,
    </li>
    <li>
      Payment Data:  to make or receive payment transactions we collect your bank/payment account
      details, such as your sort code, account number, IBAN and/or Swift code,
    </li>
    <li>
      KYC Data: if we need to verify your identity, we will ask you to provide one or more of the
      following:
    </li>
    <ul class="bullet--list">
      <li>Contact Data,</li>
      <li>Identity Data,</li>
      <li>Payment Data, and</li>
      <li>a copy of your identity document (a passport or ID card),</li>
      <li>liveness check or selfie with identity document,</li>
      <li>proof of address (such as a utility bill or account statement),</li>
      <li>PEP declaration,</li>
      <li>documents evidencing your income, occupation, type of business.</li>
    </ul>
    <li>
      Transaction Screening and Monitoring Data: includes transactions information, such as client
      name, transaction ID, status, sender details or beneficiary details; potential sanction
      matches and relevant information, or results from checks for suspicious transactions,
    </li>
    <li>
      Due Diligence (DD) Data: includes information to verify the source of your funds or wealth, to
      conduct due diligence,
    </li>
    <li>
      Voluntary Data: includes information you voluntarily provide to us, for example by
      corresponding with us (by phone, e-mail, post or social media) or by taking part in
      competitions, promotions or surveys.
    </li>
  </ul>
  <h2 class="h--large is--white">PURPOSES YOUR PERSONAL DATA IS USED FOR</h2>
  <p>We will only use your personal data when the law allows us to.</p>

  <p>Most commonly, we will use your personal data in the following circumstances:</p>
  <ul class="bullet--list">
    <li>When establishing business relationship and opening an account to provide our services,</li>
    <li>
      Where it is necessary for our legitimate interests (or those of a third party) and your
      interests and fundamental rights do not override those interests,
    </li>
    <li>Where we need to comply with a regulatory obligation,</li>
    <li>Where we need to comply with a contractual obligation.</li>
  </ul>

  <h2 class="h--large is--white">SPECIAL CATEGORIES OF PERSONAL DATA</h2>
  <p>
    Some types of personal data are designated as special categories of personal data or sensitive
    data in applicable data protection laws. This means that they are more sensitive types of
    personal data and we therefore need to take additional steps to protect this data. This includes
    details about your race or ethnicity, religious or philosophical beliefs, sex life, sexual
    orientation, political opinions, trade union membership, information about your health, and
    genetic and biometric data.
  </p>
  <p>
    If we process Payment Data, which may include special categories of personal data or personal
    data relating to criminal convictions and offences, we ensure that:
  </p>
  <ul class="bullet--list">
    <li>
      one of the exceptions in Article 9 (2) GDPR applies, i.e., processing is necessary for reasons
      of substantial public interest, and/or
    </li>
    <li>the conditions of Article 10 GDPR are met.</li>
  </ul>

  <h2 class="h--large is--white">SHARING YOUR PERSONAL DATA</h2>

  <p>We may share your personal data with third parties in the following circumstances:</p>
  <ul class="bullet--list">
    <li>AML and KYC service providers,</li>
    <li>
      banks, other financial institutions and payment service providers to enable you to upload
      funds, make payment transactions and receive funds; these providers include banks, payment
      service providers, acquirers, alternative payment providers and account information service
      providers,
    </li>
    <li>
      to the third parties such as banks, other financial institutions and payment service providers
      if we are required to disclose your information (including any KYC Data, DD Data, Transaction
      Screening and Monitoring Data) in order to assist regulatory obligations or risk assessments,
    </li>
    <li>
      with third party service providers which provide a range of services to us to enable us to run
      our business; this includes our IT and hosting providers, cloud storage providers, email
      platforms, contact relationship management system, customer service support, suppliers which
      provide screening and transaction monitoring services, credit reference agencies (to carry out
      credit checks and/or identity checks where applicable), URL monitoring providers, marketing
      firms, and our notification/communication providers,
    </li>
    <li>
      fraud prevention agencies where we are required to share personal data to comply with our
      legal or regulatory obligations or to prevent and/or detect financial crime or other illicit
      activity, competent law enforcement bodies, regulatory, government agencies, courts or other
      third parties, such as, but not limited to, the police, the supervisory authorities, the tax
      and social security agencies, as well as courts, where we believe disclosure is necessary (i)
      as a matter of applicable law or regulation, or (ii) to exercise, establish or defend our
      legal rights,
    </li>
    <li>
      other third parties, such as the police or the supervisory authorities, in response to ad hoc
      data sharing requests. In these circumstances we will only share personal data if we are
      satisfied that we are legally allowed to do so and the sharing of data is justified,
    </li>
    <li>
      third parties to which we may choose to sell, transfer or merge parts of our business or our
      assets, in this case strict non-disclosing obligations should exist,
    </li>
    <li>
      auditors, advisors, accountants, legal representatives, and similar agents in connection with
      the advisory services they provide to us for legitimate business purposes and under
      contractual prohibition of using the personal data for any other purpose, in this case strict
      non-disclosing obligations should exist,
    </li>
    <li>
      with your permission, your information may also be used for other purposes for which you give
      your specific permission.
    </li>
  </ul>
  <h2 class="h--large is--white">PERSONAL DATA STORAGE</h2>
  <p>
    Our website, App, system and cloud storage providers host personal data within the EU and the
    EEA, so your information is generally stored within this area.
  </p>
  <p>
    If we are required to transfer your personal data internationally in order for us to provide our
    services, we are committed to ensuring that all necessary safeguards are in place and that all
    assessments have been conducted prior to the transfer of your data. In particular, Draph uses
    the EU Standard Contractual Clauses and country- specific clauses, as applicable.
  </p>

  <h2 class="h--large is--white">PERSONAL DATA RETENTION PERIOD</h2>

  <p>
    We will only retain your personal data for as long as reasonably necessary, at least for a 5
    (five) years period, to fulfil the purposes we collected it for, including for the purposes of
    satisfying any legal, regulatory (including AML/CTF), tax, accounting or reporting requirements.
    We may retain your personal data for a longer period in the event we are required to do so by
    applicable regulatory requirements, in case of a complaint or if we reasonably believe there is
    a prospect of litigation in respect to our relationship with you.
  </p>

  <p>
    To determine the appropriate retention period for personal data, we consider the retention
    requirements set forth in the Act, GDPR and applicable national AML/CTF laws and regulations,
    other applicable laws and regulations, the duration of the business relationship, the amount,
    nature and sensitivity of the personal data, the potential risk of harm from unauthorised use or
    disclosure of your personal data, the purposes for which we process your personal data and
    whether we can achieve those purposes through other means, and the applicable legal, regulatory,
    tax, accounting or other requirements.
  </p>
  <p>
    For more information about the retention period applicable for your, you can contact us at any
    time using the contact details below.
  </p>
  <p>
    We generally store personal data until the purposes for processing these data have been
    achieved, unless statutory retention obligations apply (e.g., local anti-money laundering,
    commercial, or tax laws).
  </p>
  <p>
    In some circumstances you can ask us to delete your data. In some circumstances we will
    anonymise your personal data (so that it can no longer be associated with you) for research or
    statistical purposes, in which case we may use this information indefinitely without further
    notice to you.
  </p>
  <h2 class="h--large is--white">YOUR RIGHTS</h2>
  <p>
    You have a number of rights under the Act and the GDPR. These rights and how you can exercise
    them are set out in this section.
  </p>
  <p>
    We may need to ask you for proof of your identity before we can respond to a request to exercise
    any of the rights in this section and we may need to ask you for more information, for example
    to help us to locate the personal data that your request relates to.
  </p>
  <p>
    If you want to exercise any of these rights, or if you require more information, please contact
    us using the contact details below:
  </p>
  <ul class="bullet--list">
    <li>
      A right to access your information. You have a right to ask us to send you a copy of all the
      personal data that we hold about you (subject to some exceptions),
    </li>
    <li>
      A right to object to us processing your information. You have a right to object to us
      processing any personal data that we process where we are relying on legitimate interests as
      the legal ground of our processing. Your objection must be based on grounds that relate to
      your particular situation, unless it relates to direct marketing. If you make a request to
      exercise your right to object, if we have compelling legitimate grounds to carry on processing
      your personal data, we will be able to continue to do so. Otherwise, we will cease processing
      your personal data,
    </li>
    <li>
      A right to ask us not to market to you. You can ask us not to send you direct marketing. You
      can do this by following the ‘unsubscribe’ instructions in any marketing e-mails,
    </li>
    <li>
      A right to have inaccurate data corrected. You have a right to ask us to correct inaccurate
      data that we hold about you. If we are satisfied that the new data you have provided is
      accurate, we will correct your personal data as soon as possible,
    </li>
    <li>
      A right to have your data erased. You have a right to ask us to delete your personal data in
      certain circumstances, for example if we have processed your data unlawfully or if we no
      longer need the data for the purposes set out in this Privacy Policy,
    </li>
    <li>
      A right to have processing of your data restricted. You can ask us to restrict processing of
      your personal data in some circumstances, for example, if you think the personal data is
      inaccurate and we need to verify its accuracy, or if we no longer need the data but you
      require us to keep it so that you can exercise your own legal rights. Restricting your
      personal data means that we only store your personal data and don’t carry out any further
      processing on it unless you consent or we need to process the data to exercise a legal claim
      or to protect a third party or the public,
    </li>
    <li>A right to opt out/ withdraw your personal data processing consent, as applicable,</li>
    <li>
      A right to define directives regarding the processing of your personal data after your death.
    </li>
  </ul>
  <h2 class="h--large is--white">THE COOKIES</h2>
  <p>
    A cookie is a small piece of data (text file) that a website or App – when visited by a user –
    asks your browser to store on your device in order to remember information about you, such as
    your language preference or login information. Those cookies are set by us and called
    first-party cookies. We also use third-party cookies – which are cookies from a domain different
    from the domain of the website or App you are visiting – for our advertising and marketing
    efforts. More specifically, we use cookies and other tracking technologies for the following
    purposes:
  </p>
  <h2 class="h--large is--white">Performance Cookies</h2>
  <p>
    These cookies allow us to count visits and traffic sources so we can measure and improve the
    performance of our website and App. They help us to know which pages are the most and least
    popular and see how visitors move around the site and App. All information these cookies collect
    is aggregated and therefore anonymous. If you do not allow these cookies we will not know when
    you have visited our website and App, and will not be able to monitor its performance.
  </p>
  <h2 class="h--large is--white">Functional Cookies</h2>
  <p>
    These cookies enable the website to provide enhanced functionality and personalisation. They may
    be set by us or by third party providers whose services we have added to our pages. If you do
    not allow these cookies then some or all of these services may not function properly.
  </p>
  <h2 class="h--large is--white">Targeting Cookies</h2>
  <p>
    These cookies may be set through our website and App by our advertising partners. They may be
    used by those companies to build a profile of your interests and show you relevant adverts on
    other websites. They do not store directly personal information, but are based on uniquely
    identifying your browser and internet device. If you do not allow these cookies, you will
    experience less targeted advertising.
  </p>
  <h2 class="h--large is--white">Strictly Necessary Cookies</h2>
  <p>
    These cookies are necessary for the website and App to function and cannot be switched off in
    our systems. They are usually only set in response to actions made by you which amount to a
    request for services, such as setting your privacy preferences, logging in or filling in forms.
    You can set your browser to block or alert you about these cookies, but some parts of the site
    will not then work. These cookies do not store any personally identifiable information.
  </p>
  <p>
    Cookies may not contain any information that personally identifies a user, but personal data
    that we store about you may be linked to the information stored in and obtained from cookies.
  </p>
  <p>
    Please note that third parties (including, for example, advertising networks and providers of
    external services like web traffic analysis services) may also use cookies, over which we have
    no control. These cookies are likely to be analytical/performance cookies or targeting cookies.
  </p>
  <h2 class="h--large is--white">Managing cookies</h2>
  <p>
    You can manage your preferences relating to the use of cookies on our website and App through
    the settings below. Most browsers allow you to refuse to accept cookies and to delete cookies.
    The methods for doing so vary from browser to browser, and from version to version. Blocking all
    cookies will have a negative impact upon the usability of many websites. Also, by blocking
    cookies, you will not be able to use all features on our website and App.
  </p>
  <h2 class="h--large is--white">THE WEBSITE AND APP</h2>

  <p>
    We are the owner or the licensee of all intellectual property rights in our website and App, and
    in the material published on it. Those works are protected by copyright laws and treaties around
    the world. All such rights are reserved. You may print off one copy, and may download extracts,
    of any page(s) from our website and App for your personal use and you may draw the attention of
    others within your organisation to content posted on our website and App. You must not modify
    the paper or digital copies of any materials you have printed off or downloaded in any way, and
    you must not use any illustrations, photographs, video or audio sequences or any graphics
    separately from any accompanying text. Our status (and that of any identified contributors) as
    the authors of content on our website and App must always be acknowledged. You must not use any
    part of the content on our website and App for commercial purposes without obtaining a licence
    to do so from us or our licensors. If you print off, copy or download any part of our website
    and App in breach of these terms of use, your right to use our website and App will cease
    immediately and you must, at our option, return or destroy any copies of the materials you have
    made.
  </p>
  <p>
    We may update and change our website and App from time to time to reflect changes to our
    services, our clients’ needs and our business priorities.
  </p>
  <p>
    Our website and App is made available free of charge. We do not guarantee that our website and
    App, or any content on it, will always be available or be uninterrupted. We may suspend or
    withdraw or restrict the availability of all or any part of our website and App for business and
    operational reasons. We will try to give you reasonable notice of any suspension or withdrawal.
    You are also responsible for ensuring that all persons who access our website and App through
    your internet connection are aware of these terms of use and other applicable terms and
    conditions, and that they comply with them.
  </p>
  <p>
    The content on our website and App is provided for general information only. It is not intended
    to amount to advice on which you should rely. You must obtain professional or specialist advice
    before taking, or refraining from, any action on the basis of the content on our website and
    App. Although we make reasonable efforts to update the information on our website and App, we
    make no representations, warranties or guarantees, whether expressed or implied, that the
    content on our website and App is accurate, complete or up to date.
  </p>
  <p>
    Where our website contains links to other websites and resources provided by third parties,
    these links are provided for your information only. Such links should not be interpreted as
    approval by us of those linked websites or information you may obtain from them. We have no
    control over the contents of those websites or resources.
  </p>
  <p>
    We do not exclude or limit in any way our liability to you where it would be unlawful to do so.
    This includes liability for death or personal injury caused by our negligence or the negligence
    of our employees, agents or subcontractors and for fraud or fraudulent misrepresentation.
    Different limitations and exclusions of liability will apply to liability arising as a result of
    the supply of any products and services to you, which will be set out in the Terms of Service
    governing those services.
  </p>
  <p class="p-policy">
    If you are a business client, we exclude all implied conditions, warranties, representations or
    other terms that may apply to our website and App or any content on them.
  </p>
  <p class="p-policy">
    We will not be liable to you for any loss or damage, whether in contract, tort (including
    negligence), breach of statutory duty, or otherwise, even if foreseeable, arising under or in
    connection with: (i) use of, or inability to use, our website and App; or (ii) use of or
    reliance on any content displayed on our website and App. In particular, we will not be liable
    for: (i) loss of profits, sales, business, or revenue; (ii) business interruption; (iii) loss of
    anticipated savings; (iv) loss of business opportunity, goodwill or reputation; or (v) any
    indirect or consequential loss or damage.
  </p>
  <p class="p-policy">
    If you are a private individual, please note that we only provide our website and App for
    domestic and private use. You agree not to use our website and App for any commercial or
    business purposes, and we have no liability to you for any loss of profit, loss of business,
    business interruption, or loss of business opportunity. If defective digital content that we
    have supplied has damaged a device or digital content belonging to you and this is caused by our
    failure to use reasonable care and skill, we will either repair the damage or pay you
    compensation. However, we will not be liable for damage that you could have avoided by following
    our advice to apply an update offered to you free of charge or for damage that was caused by you
    failing to correctly follow installation instructions or to have in place the minimum system
    requirements advised by us.
  </p>
  <p class="p-policy">
    We do not guarantee that our website and App will be secure or free from bugs or viruses. You
    are responsible for configuring your information technology, computer programmes and platform to
    access our website and App. You should use your own virus protection software. You must not
    misuse our website and App by knowingly introducing viruses, trojans, worms, logic bombs or
    other material that is malicious or technologically harmful. You must not attempt to gain
    unauthorised access to our website and App, the server on which our website and App is stored or
    any server, computer or database connected to our website and App. You must not attack our
    website and App via a denial-of-service attack or a distributed denial-of service attack. We
    will report any such breach to the relevant law enforcement authorities and we will cooperate
    with those authorities by disclosing your identity to them. In the event of such a breach, your
    right to use our website and App will cease immediately.
  </p>
  <p class="p-policy">
    You may link to our website and App, provided you do so in a way that is fair and legal and does
    not damage our reputation or take advantage of it. You must not establish a link in such a way
    as to suggest any form of association, approval or endorsement on our part where none exists.
    You must not establish a link to our website and App in any website that is not owned by you.
    Our website and App must not be framed on any other website, nor may you create a link to any
    part of our website other than the home page. We reserve the right to withdraw linking
    permission without notice.
  </p>
  <h2 class="h--large is--white">CONTACTING US</h2>
  <p class="p-policy">
    If you have any questions or concerns about this Privacy Policy and/or our processing of your
    personal data, you can contact us by using the contact form on our website, by sending us a
    message to our Customer Support team to the e-mail address
    <a href="mailto:support&#64;swipez.eu">support&#64;swipez.eu</a>.
  </p>
  <p class="p-policy">
    If the issue cannot be considered by our Customer Support team, you submit a complaint in the
    order set in our Complaint Disclaimer available on our website.
  </p>
  <h2 class="h--large is--white">CHANGES TO THE PRIVACY POLICY</h2>
  <p class="p-policy">
    We may make changes to this Privacy Policy from time to time. Any changes we make will be posted
    on the webpage. We may also notify you by e-mail or system if significant changes are made.
  </p>
  <p></p>
  <p>Last updated: 01.10.2024</p>
</template>
